/* Lazy autoplay for blocks/video.liquid — zero-dep, deferred.
 *
 * `<video>` has no `loading="lazy"`, and the `autoplay` attribute overrides `preload`
 * in Firefox and Safari, so a below-the-fold autoplay clip downloads in full during
 * the LCP window. The block therefore ships preload="none" and NO autoplay attribute;
 * this starts it when it comes near the viewport and pauses it when it leaves, so a
 * visitor who never scrolls past pays nothing and one who scrolls back does not decode
 * a clip they cannot see. Same shape as the ugc tile gate in ugc-player.js.
 *
 * Reduced motion: bail entirely. The CSS hides the <video> and shows the poster <img>,
 * so anything started here would be playing behind a picture.
 */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const vids = document.querySelectorAll('[data-video-lazy]');
  if (!vids.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        const v = e.target;
        if (e.isIntersecting) {
          // preload is only advisory once play() is called, but setting it first is
          // what lets a browser that ignores autoplay policy start buffering early.
          v.preload = 'auto';
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      }
    },
    { rootMargin: '200px' }
  );

  vids.forEach((v) => io.observe(v));
})();
